export const translations = {
  it: {
    nav: {
      about: "Chi siamo",
      musicians: "Musicisti",
      discography: "Discografia",
      concerts: "Concerti",
      gallery: "Galleria",
      contact: "Contatti",
    },
    hero: {
      overline: "Ensemble da camera — dal 2016",
      title: "Proscenio",
      titleAccent: "Ensemble",
      subtitle: "Un viaggio nella raffinatezza della musica.",
      cta: "Scopri il progetto",
      ctaSecondary: "Ascolta",
    },
    about: {
      overline: "Chi siamo",
      title: "Una formazione modulabile per la voce, il clarinetto e il pianoforte",
      paragraphs: [
        "Il Proscenio Ensemble nasce nel 2016 da un progetto artistico-musicale di Stefano Ongaro. Nella sua fase nascente la formazione aveva il nome di LiederTrio ed era costituita da voce, clarinetto e pianoforte; solo dopo il suo scioglimento ed una riorganizzazione il progetto ha potuto riprendere forma e svilupparsi.",
        "Assieme a Stefano Ongaro (clarinetto, clarinetto basso e corno di bassetto) é co-fondatrice Lucia Porri (soprano del Proscenio Ensemble).",
        "Presenza importante dell'ensemble é la voce, tramite espressivo principale (articolata in soprano, mezzosoprano e baritono) che affianca il clarinetto, clarinetto basso, corno di bassetto e pianoforte. Nella formazione sono inseriti altri timbri strumentali con archi ed altri fiati.",
        "L'ensemble propone il repertorio più famoso e meno noto per voci, clarinetti e pianoforte, ed é alla continua ricerca di composizioni da riscoprire e proporre al suo pubblico. Esegue anche repertorio strumentale legato a particolarità timbriche o ad autori specifici, in progetti curati da Stefano Ongaro.",
        "L'organico è modulabile in base al repertorio affrontato — dalla musica classica a quella moderna, fino alle colonne sonore.",
      ],
      stats: [
        { value: "2016", label: "Anno di fondazione" },
        { value: "2", label: "Album discografici" },
        { value: "15+", label: "Musicisti coinvolti" },
      ],
    },
    musicians: {
      overline: "Musicisti",
      title: "Chi c'è dietro la musica",
      subtitle: "Voci e strumentisti del Proscenio Ensemble e del Proscenio Baroque Ensemble.",
      groups: [
        {
          name: "Voci",
          members: [
            "Lucia Porri — soprano",
            "Laura De Silva — soprano",
            "Maria Lucia Bazza — mezzosoprano",
            "Eugenia Zuin — contralto",
            "Pierluca Porri — baritono",
            "Michael Miazzi — basso",
          ],
        },
        {
          name: "Clarinetti & Pianoforte",
          members: [
            "Stefano Ongaro — clarinetto, clarinetto basso, corno di bassetto",
            "Cristiano Zanellato — pianoforte",
            "Paolo Lazzarini — pianoforte",
            "Ilaria Barbagin — pianoforte",
          ],
        },
        {
          name: "Tasti antichi",
          members: ["Marco Golinelli — clavicembalo, organo"],
        },
        {
          name: "Archi",
          members: [
            "Francesca Benesso — violino",
            "Anna Beltrami — violino",
            "Galina Berghi — violino",
            "Michael Miazzi — violino",
            "Flaminia Virdis — viola",
            "Giulio Baraldi — viola",
            "Stela Marku — viola",
            "Paolo Tomasini — violoncello",
            "Cecilia Zanni — violoncello",
            "Caterina Colelli — violoncello barocco",
          ],
        },
        {
          name: "Fiati",
          members: [
            "Ludovica La Marca — oboe",
            "Fabiana Sommariva — oboe",
            "Marina Martelli — fagotto",
          ],
        },
        {
          name: "Chitarra",
          members: ["José Angel Ramirez Rogoitia — chitarra"],
        },
      ],
    },
    discography: {
      overline: "Discografia",
      title: "Due progetti pubblicati da Da Vinci Publishing — Osaka",
      albums: [
        {
          title: "Sonorités Oubliées",
          year: "2023",
          description:
            "Musica da camera del XIX secolo per clarinetto basso e corno di bassetto in duo con il pianoforte. Tredici tracce con musiche di Danzi, Diethe, Rummel, Klughardt, Koch, Rasse, Meyerbeer, Pillevestre.",
        },
        {
          title: "Ô doux printemps d'autrefois",
          year: "2020",
          description:
            "Dedicato alla musica vocale da camera per voci, clarinetti e pianoforte. Arie di Braga, Donizetti, Lachner, Massenet, Obiols, Proch.",
        },
      ],
      listenSpotify: "Ascolta su Spotify",
    },
    concerts: {
      overline: "Calendario",
      title: "Concerti",
      subtitle: "Date dei concerti del Proscenio Ensemble e del Proscenio Baroque Ensemble.",
      upcoming: "In programma",
      past: "Concerti passati",
      empty: "Nessun concerto in programma al momento.",
    },
    gallery: {
      overline: "Galleria",
      title: "L'ensemble in scena",
      subtitle: "Immagini di concerti, sale e ambienti che hanno ospitato il nostro repertorio.",
    },
    contact: {
      overline: "Contatti",
      title: "Mettiti in contatto",
      subtitle: "Per informazioni, programmazioni concertistiche o collaborazioni artistiche.",
      address: "Piazza Giuseppe Mazzini, 13 — 44030 Ro (FE), Italia",
      email: "proscenioensemble@ongarostefano.it",
      phones: ["+39.0532.869106", "+39.334.8084704"],
      form: {
        name: "Nome e cognome",
        email: "Email",
        subject: "Oggetto (opzionale)",
        message: "Messaggio",
        send: "Invia messaggio",
        sending: "Invio in corso…",
        success: "Grazie! Il messaggio è stato inviato.",
        error: "Si è verificato un errore. Riprova più tardi.",
      },
    },
    footer: {
      tagline: "Un viaggio nella raffinatezza della musica.",
      rights: "Tutti i diritti riservati.",
    },
  },
  en: {
    nav: {
      about: "About",
      musicians: "Musicians",
      discography: "Discography",
      concerts: "Concerts",
      gallery: "Gallery",
      contact: "Contact",
    },
    hero: {
      overline: "Chamber ensemble — since 2016",
      title: "Proscenio",
      titleAccent: "Ensemble",
      subtitle: "A journey into the refinement of music.",
      cta: "Discover the project",
      ctaSecondary: "Listen",
    },
    about: {
      overline: "About us",
      title: "A flexible chamber formation for voice, clarinet and piano",
      paragraphs: [
        "Proscenio Ensemble was founded in 2016 from an artistic-musical project by Stefano Ongaro. In its early years the group was named LiederTrio and consisted of voice, clarinet and piano; after its dissolution and reorganisation the project took its current shape.",
        "Co-founder alongside Stefano Ongaro (clarinet, bass clarinet, basset horn) is Lucia Porri (soprano of Proscenio Ensemble).",
        "Voice is the ensemble's main expressive vehicle — articulated through soprano, mezzo-soprano and baritone — paired with clarinet, bass clarinet, basset horn and piano. Strings and other winds enrich the colour palette.",
        "The ensemble explores the most celebrated and lesser-known repertoire for voices, clarinets and piano, constantly rediscovering compositions to share with audiences. It also performs purely instrumental programmes shaped around timbral specificities or specific composers, curated by Stefano Ongaro.",
        "The line-up is modular and adapts to the chosen repertoire — from classical to modern works, including film scores.",
      ],
      stats: [
        { value: "2016", label: "Year of foundation" },
        { value: "2", label: "Studio albums" },
        { value: "15+", label: "Musicians involved" },
      ],
    },
    musicians: {
      overline: "Musicians",
      title: "The voices behind the music",
      subtitle: "Singers and instrumentalists of the Proscenio Ensemble and Proscenio Baroque Ensemble.",
      groups: [
        {
          name: "Voices",
          members: [
            "Lucia Porri — soprano",
            "Laura De Silva — soprano",
            "Maria Lucia Bazza — mezzo-soprano",
            "Eugenia Zuin — contralto",
            "Pierluca Porri — baritone",
            "Michael Miazzi — bass",
          ],
        },
        {
          name: "Clarinets & Piano",
          members: [
            "Stefano Ongaro — clarinet, bass clarinet, basset horn",
            "Cristiano Zanellato — piano",
            "Paolo Lazzarini — piano",
            "Ilaria Barbagin — piano",
          ],
        },
        {
          name: "Early keyboards",
          members: ["Marco Golinelli — harpsichord, organ"],
        },
        {
          name: "Strings",
          members: [
            "Francesca Benesso — violin",
            "Anna Beltrami — violin",
            "Galina Berghi — violin",
            "Michael Miazzi — violin",
            "Flaminia Virdis — viola",
            "Giulio Baraldi — viola",
            "Stela Marku — viola",
            "Paolo Tomasini — cello",
            "Cecilia Zanni — cello",
            "Caterina Colelli — baroque cello",
          ],
        },
        {
          name: "Winds",
          members: [
            "Ludovica La Marca — oboe",
            "Fabiana Sommariva — oboe",
            "Marina Martelli — bassoon",
          ],
        },
        {
          name: "Guitar",
          members: ["José Angel Ramirez Rogoitia — guitar"],
        },
      ],
    },
    discography: {
      overline: "Discography",
      title: "Two albums released by Da Vinci Publishing — Osaka",
      albums: [
        {
          title: "Sonorités Oubliées",
          year: "2023",
          description:
            "19th-century chamber music for bass clarinet and basset horn in duo with piano. Thirteen tracks featuring works by Danzi, Diethe, Rummel, Klughardt, Koch, Rasse, Meyerbeer, Pillevestre.",
        },
        {
          title: "Ô doux printemps d'autrefois",
          year: "2020",
          description:
            "Devoted to vocal chamber music for voices, clarinets and piano. Arias by Braga, Donizetti, Lachner, Massenet, Obiols, Proch.",
        },
      ],
      listenSpotify: "Listen on Spotify",
    },
    concerts: {
      overline: "Calendar",
      title: "Concerts",
      subtitle: "Performance dates of the Proscenio Ensemble and Proscenio Baroque Ensemble.",
      upcoming: "Upcoming",
      past: "Past concerts",
      empty: "No scheduled concerts at the moment.",
    },
    gallery: {
      overline: "Gallery",
      title: "The ensemble on stage",
      subtitle: "Images of performances, halls and venues that hosted our repertoire.",
    },
    contact: {
      overline: "Contact",
      title: "Get in touch",
      subtitle: "For information, concert programming or artistic collaborations.",
      address: "Piazza Giuseppe Mazzini, 13 — 44030 Ro (FE), Italy",
      email: "proscenioensemble@ongarostefano.it",
      phones: ["+39.0532.869106", "+39.334.8084704"],
      form: {
        name: "Full name",
        email: "Email",
        subject: "Subject (optional)",
        message: "Message",
        send: "Send message",
        sending: "Sending…",
        success: "Thank you! Your message has been sent.",
        error: "An error occurred. Please try again later.",
      },
    },
    footer: {
      tagline: "A journey into the refinement of music.",
      rights: "All rights reserved.",
    },
  },
};
